import { render, staticRenderFns } from "./SnackbarError.vue?vue&type=template&id=817531a2&lang=pug&"
import script from "./SnackbarError.vue?vue&type=script&lang=js&"
export * from "./SnackbarError.vue?vue&type=script&lang=js&"
import style0 from "./SnackbarError.vue?vue&type=style&index=0&id=817531a2&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports